<template>
  <RModal
    ref="modal"
    full-size
    :title="contact ? 'Edit Contact' : 'Create Contact'"
    :ok-btn-label="contact ? 'Save' : 'Create'"
    @hide="$emit('input', false)"
    @cancel="$event()"
    @ok="save"
  >
    <div class="modal-content">
      <Grid gtc="1fr 1fr 1fr" gap="0 var(--r-space-xxl)" class="q-mt-md">
        <div class="text-body-3 text-secondary-2 q-pb-md">Basic</div>
        <div class="text-body-3 text-secondary-2 q-pb-md">Address</div>
        <div class="text-body-3 text-secondary-2 q-pb-md">Email Preferences</div>

        <BasicFields ref="basicFields" :initial-fields="copiedContact" />
        <AddressFields ref="addressFields" :initial-address="addresses" />
        <div>
          <PreferencesFields ref="preferencesFields" :initial-preferences="copiedContact.email_preferences || []" />

          <div class="text-body-3 text-secondary-2 q-mt-md">Primary contact</div>

          <RCheckbox v-model="isPrimary" class="t-mt-md" label="Is Primary" />
        </div>
      </Grid>
    </div>
  </RModal>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
// Components
import RModal from '@/ui/RModal'
import BasicFields from './BasicFields'
import AddressFields from '@/reusable/address-fields/AddressFields'
import PreferencesFields from './PreferencesFields'

export default {
  components: {
    RModal,
    BasicFields,
    AddressFields,
    PreferencesFields
  },

  props: {
    value: Boolean,
    onSave: Function,
    contact: Object,
    mainAddress: {
      type: Object,
      required: true
    },
    provider: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    copiedContact: {},
    isPrimary: false
  }),

  computed: {
    addresses() {
      return this.copiedContact.addresses?.[0] || { address_type: this.mainAddress.address_type }
    }
  },

  watch: {
    value(newVal) {
      if (newVal) {
        if (this.contact) {
          this.copiedContact = cloneDeep(this.contact)
          this.isPrimary = this.contact.is_primary
        } else this.isPrimary = false
        this.$refs.modal.show()
      } else this.$emit('input', false)
    }
  },

  methods: {
    save(hideModal, setModalLoading) {
      const payload = {
        ...this.$refs.basicFields.getPayload(),
        addresses: [this.$refs.addressFields.getPayload()],
        email_preferences: this.$refs.preferencesFields.getPayload(),
        provider_id: this.provider.id,
        is_primary: this.isPrimary
      }

      if (this.onSave) {
        this.onSave(payload, setModalLoading, hideModal)
        return
      }

      setModalLoading(true)

      const createOrUpdateApi = this.contact
        ? () => apiTo.UPDATE_CONTACT(this.contact.id, payload)
        : () => apiTo.CREATE_CONTACT(payload)

      createOrUpdateApi()
        .then(({ data }) => {
          this.$emit(this.contact ? 'updated' : 'created', data.result)
          this.$emit('input', false)
          hideModal()
        })
        .finally(() => setModalLoading(false))
    }
  }
}
</script>

<style lang="scss" scoped></style>
